var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.006 14.095 3.444 17l1.062-6.152L0 6.492l6.219-.895L9 0l2.781 5.597L18 6.492l-4.506 4.356L14.556 17l-5.55-2.905Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.08 12.323a2 2 0 0 1 1.854 0l1.962 1.028-.373-2.162a2 2 0 0 1 .58-1.779l1.573-1.52-2.18-.314a2 2 0 0 1-1.506-1.09L9 4.495l-.99 1.993a2 2 0 0 1-1.506 1.09l-2.18.313 1.572 1.52a2 2 0 0 1 .581 1.779l-.374 2.166 1.978-1.032ZM3.445 17l1.062-6.152L0 6.492l6.219-.895L9 0l2.781 5.597L18 6.492l-4.506 4.356L14.556 17l-5.55-2.905L3.444 17Z",
  clipRule: "evenodd"
}))));
export default SvgIconStarFilled;